import { msg, optionalEmailSchema } from '~/utils/validation';
import { z } from 'zod';

export const baseSchema = z.object({
  email: optionalEmailSchema,
  website: z.string().nullish(),
});

export const schema = z
  .object({
    name: z.string().min(1, { message: msg.required }),
    region: z.coerce
      .string()
      .optional()
      .transform(s => (s ? Number(s) : undefined)),
  })
  .merge(baseSchema);

export type Schema = z.infer<typeof schema>;
